import dayjs from 'dayjs';
import React from 'react';
import { Image, Typography } from 'tfc-components';

import Icon from 'components/atoms/Icon';

export type ITarget = '_blank' | '_self' | '_parent' | '_top';

interface INewsCardProps {
  img: string;
  imgAlt?: string;
  title: string;
  description?: string;
  dateTime?: string;
  maxLengthDescription?: number;
  maxLengthTitle?: number;
  small?: boolean;
  link?: string;
  target?: ITarget;
}

function truncate(str: string, n?: number) {
  if (!n) return str;
  return str.length > n ? `${str.substr(0, n - 1)}...` : str;
}

const NewsCard: React.FC<INewsCardProps> = ({
  img, title, description, dateTime, imgAlt,
  maxLengthDescription, maxLengthTitle, small,
  link, target = '_blank',
}) => (
  <div
    onClick={() => link && window.open(link, target)}
    className="m-newsCard"
  >
    <div
      className="m-newsCard_item"
    >
      <div className="m-newsCard_imageWrap">
        <Image
          extendClasses="m-newsCard_image"
          imgSrc={img}
          alt={imgAlt || ''}
          ratio={3 / 2}
        />
      </div>
      <div className="m-newsCard_content">
        {small ? (
          <Typography.Text
            extendClasses="m-newsCard_title fs-16x20"
          >
            {truncate(title, maxLengthTitle)}
          </Typography.Text>
        ) : (
          <Typography.Text
            fontweight="600"
            extendClasses="m-newsCard_title fs-20x24"
          >
            {truncate(title, maxLengthTitle)}
          </Typography.Text>
        )}
        {description?.trim() && (
          <div
            className="m-newsCard_description"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: truncate(description, maxLengthDescription),
            }}
          />
        )}
        {dateTime && (
          <div className="m-newsCard_dateWrap">
            <div className="m-newsCard_date">
              <span><Icon iconName="calendarBlankGray" size="16" /></span>
              <Typography.Text extendClasses="m-newsCard_dateText fs-14x16">
                {dayjs(dateTime).format('DD/MM/YYYY')}
              </Typography.Text>
            </div>
            <div className="m-newsCard_date">
              <span><Icon iconName="clockGray" size="16" /></span>
              <Typography.Text extendClasses="m-newsCard_dateText fs-14x16">
                {dayjs(dateTime).format('HH:mm:ss')}
              </Typography.Text>
            </div>
          </div>
        )}
      </div>
    </div>
  </div>
);

export default NewsCard;
